/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { MediaItem } from '../models/media-item';
import { userControllerCount } from '../fn/user/user-controller-count';
import { UserControllerCount$Params } from '../fn/user/user-controller-count';
import { userControllerCreate } from '../fn/user/user-controller-create';
import { UserControllerCreate$Params } from '../fn/user/user-controller-create';
import { userControllerDelete } from '../fn/user/user-controller-delete';
import { UserControllerDelete$Params } from '../fn/user/user-controller-delete';
import { userControllerDeleteImage } from '../fn/user/user-controller-delete-image';
import { UserControllerDeleteImage$Params } from '../fn/user/user-controller-delete-image';
import { userControllerFind } from '../fn/user/user-controller-find';
import { UserControllerFind$Params } from '../fn/user/user-controller-find';
import { userControllerFindOne } from '../fn/user/user-controller-find-one';
import { UserControllerFindOne$Params } from '../fn/user/user-controller-find-one';
import { userControllerFindOneWithDetails } from '../fn/user/user-controller-find-one-with-details';
import { UserControllerFindOneWithDetails$Params } from '../fn/user/user-controller-find-one-with-details';
import { userControllerFindRoles } from '../fn/user/user-controller-find-roles';
import { UserControllerFindRoles$Params } from '../fn/user/user-controller-find-roles';
import { userControllerGetMyself } from '../fn/user/user-controller-get-myself';
import { UserControllerGetMyself$Params } from '../fn/user/user-controller-get-myself';
import { userControllerStats } from '../fn/user/user-controller-stats';
import { UserControllerStats$Params } from '../fn/user/user-controller-stats';
import { userControllerUpdate } from '../fn/user/user-controller-update';
import { UserControllerUpdate$Params } from '../fn/user/user-controller-update';
import { userControllerUpdateCredentials } from '../fn/user/user-controller-update-credentials';
import { UserControllerUpdateCredentials$Params } from '../fn/user/user-controller-update-credentials';
import { userControllerUploadPicture } from '../fn/user/user-controller-upload-picture';
import { UserControllerUploadPicture$Params } from '../fn/user/user-controller-upload-picture';
import { UserCountResponse } from '../models/user-count-response';
import { UserItem } from '../models/user-item';
import { UserItemMinimal } from '../models/user-item-minimal';
import { UserListResponse } from '../models/user-list-response';
import { UserRoleListResponse } from '../models/user-role-list-response';
import { UserStatsResponse } from '../models/user-stats-response';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userControllerFind()` */
  static readonly UserControllerFindPath = '/user';

  /**
   * Restituisce l'elenco degli utenti e i loro ruoli.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFind()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFind$Response(params?: UserControllerFind$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserListResponse;
}>> {
    const obs = userControllerFind(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce l'elenco degli utenti e i loro ruoli.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFind$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFind(params?: UserControllerFind$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserListResponse;
}> {
    const resp = this.userControllerFind$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserListResponse;
}>): BaseResponse & {
'data'?: UserListResponse;
} => r.body)
    );
  }

  /** Path part for operation `userControllerCreate()` */
  static readonly UserControllerCreatePath = '/user';

  /**
   * Crea un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreate$Response(params: UserControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    const obs = userControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Crea un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreate(params: UserControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    const resp = this.userControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `userControllerFindOne()` */
  static readonly UserControllerFindOnePath = '/user/{id}';

  /**
   * Restituisce le informazioni minime di un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindOne$Response(params: UserControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    const obs = userControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce le informazioni minime di un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindOne(params: UserControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    const resp = this.userControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `userControllerDelete()` */
  static readonly UserControllerDeletePath = '/user/{id}';

  /**
   * Elimina un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerDelete$Response(params: UserControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItemMinimal;
}>> {
    const obs = userControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Elimina un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerDelete(params: UserControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItemMinimal;
}> {
    const resp = this.userControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItemMinimal;
}>): BaseResponse & {
'data'?: UserItemMinimal;
} => r.body)
    );
  }

  /** Path part for operation `userControllerUpdate()` */
  static readonly UserControllerUpdatePath = '/user/{id}';

  /**
   * Modifica un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdate$Response(params: UserControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    const obs = userControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Modifica un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdate(params: UserControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    const resp = this.userControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `userControllerFindOneWithDetails()` */
  static readonly UserControllerFindOneWithDetailsPath = '/user/{id}/detail';

  /**
   * Restituisce tutte le informazioni di un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindOneWithDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindOneWithDetails$Response(params: UserControllerFindOneWithDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    const obs = userControllerFindOneWithDetails(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce tutte le informazioni di un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindOneWithDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindOneWithDetails(params: UserControllerFindOneWithDetails$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    const resp = this.userControllerFindOneWithDetails$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `userControllerUploadPicture()` */
  static readonly UserControllerUploadPicturePath = '/user/{id}/picture';

  /**
   * Carica la foto profilo per utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUploadPicture()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  userControllerUploadPicture$Response(params: UserControllerUploadPicture$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    const obs = userControllerUploadPicture(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Carica la foto profilo per utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUploadPicture$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  userControllerUploadPicture(params: UserControllerUploadPicture$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    const resp = this.userControllerUploadPicture$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `userControllerDeleteImage()` */
  static readonly UserControllerDeleteImagePath = '/user/{id}/picture';

  /**
   * Carica la foto profilo per utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerDeleteImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerDeleteImage$Response(params: UserControllerDeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaItem;
}>> {
    const obs = userControllerDeleteImage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Carica la foto profilo per utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerDeleteImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerDeleteImage(params: UserControllerDeleteImage$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaItem;
}> {
    const resp = this.userControllerDeleteImage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaItem;
}>): BaseResponse & {
'data'?: MediaItem;
} => r.body)
    );
  }

  /** Path part for operation `userControllerFindRoles()` */
  static readonly UserControllerFindRolesPath = '/user/role';

  /**
   * Restituisce l'elenco dei ruoli.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindRoles$Response(params?: UserControllerFindRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserRoleListResponse;
}>> {
    const obs = userControllerFindRoles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce l'elenco dei ruoli.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindRoles(params?: UserControllerFindRoles$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserRoleListResponse;
}> {
    const resp = this.userControllerFindRoles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserRoleListResponse;
}>): BaseResponse & {
'data'?: UserRoleListResponse;
} => r.body)
    );
  }

  /** Path part for operation `userControllerGetMyself()` */
  static readonly UserControllerGetMyselfPath = '/user/myself';

  /**
   * Restituisce la propria utenza.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetMyself()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetMyself$Response(params?: UserControllerGetMyself$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    const obs = userControllerGetMyself(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce la propria utenza.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetMyself$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetMyself(params?: UserControllerGetMyself$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    const resp = this.userControllerGetMyself$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `userControllerStats()` */
  static readonly UserControllerStatsPath = '/user/stats';

  /**
   * Restituisce il numero di utenti divisi per ruolo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerStats$Response(params?: UserControllerStats$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserStatsResponse;
}>> {
    const obs = userControllerStats(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce il numero di utenti divisi per ruolo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerStats(params?: UserControllerStats$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserStatsResponse;
}> {
    const resp = this.userControllerStats$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserStatsResponse;
}>): BaseResponse & {
'data'?: UserStatsResponse;
} => r.body)
    );
  }

  /** Path part for operation `userControllerCount()` */
  static readonly UserControllerCountPath = '/user/count';

  /**
   * Restituisce il numero di utenti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerCount$Response(params?: UserControllerCount$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserCountResponse;
}>> {
    const obs = userControllerCount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce il numero di utenti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerCount(params?: UserControllerCount$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserCountResponse;
}> {
    const resp = this.userControllerCount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserCountResponse;
}>): BaseResponse & {
'data'?: UserCountResponse;
} => r.body)
    );
  }

  /** Path part for operation `userControllerUpdateCredentials()` */
  static readonly UserControllerUpdateCredentialsPath = '/user/{id}/credentials';

  /**
   * Modifica le credenziali di un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdateCredentials()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateCredentials$Response(params: UserControllerUpdateCredentials$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    const obs = userControllerUpdateCredentials(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Modifica le credenziali di un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdateCredentials$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateCredentials(params: UserControllerUpdateCredentials$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    const resp = this.userControllerUpdateCredentials$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

}
